import { branchCount } from "./branchCount";
import { sortStats } from "./utils";

/**
 * Processa um  caminho de ramo 'branch' e retorna os tempos totalizados,
 * as estatísticas e o próximo item a ser processado.
 * @param {Elements} elements - Os elementos do fluxo.
 * @param {NodeElement} item - O item a ser processado.
 * @param {Array} stats - O array de estatísticas.
 * @param {number} branchTime - O tempo total do caminho crítico até o momento.
 * @param {number} doneTime - O tempo total das tarefas já realizadas até o momento.
 * @param {number} donePreventTime - O tempo total das preventivas já realizadas até o momento.
 * @returns {{ branchTime: number, doneTime: number, donePreventTime: number, next: NodeElement, task: NodeElement }}
 */
export function processBranch(
  elements,
  item,
  stats,
  branchTime,
  doneTime,
  donePreventTime
) {
  const finishBranchItem = branchCount(elements, item, stats);

  branchTime += finishBranchItem.max;
  doneTime += finishBranchItem.maxDone;
  donePreventTime += finishBranchItem.maxPreventDone;

  stats.push(...finishBranchItem.stats);
  sortStats(stats);

  const next = finishBranchItem.lastItem
    ? elements.find((e) => e.source === finishBranchItem.lastItem.id)
    : null;

  return {
    branchTime,
    doneTime,
    donePreventTime,
    next,
    task: finishBranchItem.task,
  };
}
